
import React, { useEffect } from 'react'; // useEffect might become unused
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthCheck } from '../hooks/useAuthCheck';
import { LoadingSpinner } from '../components/LoadingSpinner';
import { PUBLIC_PATHS } from '../constants';
// import { useDataContext } from '@/context/DataContext'; // Removed
import { getAuth } from 'firebase/auth'; // May become unused if firebaseUser is passed from useAuthCheck or not needed here
// import { initializeUserData } from '@/utils/firestore/users/auth'; // Initialization now handled in useAuthCheck

interface AuthenticatedRouteProps {
  children: React.ReactNode;
}

export const AuthenticatedRoute: React.FC<AuthenticatedRouteProps> = ({ children }) => {
  const location = useLocation();
  const { isLoading, isAuthenticated } = useAuthCheck(); // Removed dataLoaded
  // const { appData } = useDataContext(); // Removed
  // const auth = getAuth(); // firebaseUser is now managed within useAuthCheck primarily
  
  // Check if current path is a public path that shouldn't require authentication
  const isPublicPath = PUBLIC_PATHS.some(path => 
    location.pathname === path || location.pathname.startsWith(path)
  );
  
  // Check if we're on the business edit page
  const isBusinessEditPath = location.pathname.includes('/business/') && location.pathname.includes('/edit');
  
  // Check if we're on the login page
  const isLoginPage = location.pathname === '/login';
  
  // The useEffect for initializeUserIfNeeded is removed as this logic is now centralized in useAuthCheck.
  // useAuthCheck's isLoading state will remain true until Firebase auth state and Firestore user document are resolved.
  
  // If we're already on the login page, don't show loading
  if (isLoginPage) {
    return <>{children}</>;
  }
  
  // Show loading spinner while useAuthCheck is determining auth status and loading user data.
  if (isLoading) {
    return <LoadingSpinner />;
  }
  
  // If it's a public path or user is authenticated, render the children
  if (isPublicPath || isAuthenticated) {
    return <>{children}</>;
  }
  
  // If we're on the business edit page, keep the URL when redirecting to login
  if (isBusinessEditPath) {
    console.log('ProtectedRoute: Redirecting to login with business edit return path:', location.pathname);
    sessionStorage.setItem('returnToEditPage', location.pathname);
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // Otherwise, redirect to login page with a return URL
  return <Navigate to="/login" state={{ from: location }} replace />;
};

export default AuthenticatedRoute;
